export default "__VITE_ASSET__BCE1wj6s__"